<template>
    <div id="dashboard-settings" class="modal inmodal fade" role="dialog" aria-hidden="true" data-backdrop="static" tabindex="-1" :style="visible ? 'display: block;' : 'display: none;'">
        <div class="modal-dialog">
            <div class="modal-content animated fadeInUp">
                <modal-header innerClass="d-flex modal-header-dialog-painting justify-space-between w-100 text-h5" :title="t_title"/>
                <div class="modal-body overflow-hidden" :style="'max-height: ' + maxBodyHeight + 'px;'">
                    <loading-placeholder v-if="loading" />
                    <div v-else class="row design-row" ref="designRow scrollBox">
                        <div class="col-md-4" :style="'height: ' + maxInnerHeight + 'px;'">
                            <h2>{{ t_dashlets }}</h2>
                            <div v-bind:style="frameStyles" ref="dashlets-list" class="dashlets-list scrollBox">
                                <dashlet v-for="(dashletName, index) in initUnusedDashlets" :name="dashletName" :settings="dashletSettings[dashletName]" :key="index"></dashlet>
                            </div>
                        </div>
                        <div class="col-md-8 dashboard-frame" >
                            <h2 ref="titleRow" style="z-index: 1; position: relative;">{{ t_layout }}</h2>
                            <div class="row">
                                <div class="col-md-6 dashboard-col-col col1">
                                    <div id="dashboard-col-1" class="dashboard-col scrollBox" v-bind:style="frameStyles">
                                        <div ref="dashboard-canvas-1" class="dashboard-canvas">
                                            <dashlet v-for="(dashletName, index) in initCol1Dashlets" :name="dashletName" :settings="dashletSettings[dashletName]" :key="index"></dashlet>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 dashboard-col-col col2">
                                    <div id="dashboard-col-2" class="dashboard-col scrollBox" v-bind:style="frameStyles">
                                        <div ref="dashboard-canvas-2" class="dashboard-canvas">
                                            <dashlet v-for="(dashletName, index) in initCol2Dashlets" :name="dashletName" :settings="dashletSettings[dashletName]" :key="index"></dashlet>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <v-btn type="button" class="btn btn-primary submit" @click="updateDashboardData">
                        <i v-if="saving" class="fa-regular fa-spinner fa-spin-pulse m-r-xs"></i>
                        {{ t_save }}
                    </v-btn>
                    <v-btn type="button" class="btn btn-secondary" data-dismiss="modal">{{ t_cancel }}
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import modalMixin from "../../common/modal-mixin";
    import dragula from "dragula";
    import dashlet from "./mini-dashlet";
    import ModalHeader from '../../content/common/modal/modal-header.vue'
    import LoadingPlaceholder from '../../content/common/loadingPlaceholder.vue'

    export default {
        mixins: [
            modalMixin,
        ],
        components: {
            LoadingPlaceholder,
            ModalHeader,
            dashlet,
        },
        data: function () {
            return {
                t_loading: Lang.langGet("Loading..."),
                t_title: Lang.langGet("Dashboard Layout"),
                t_dashlets: Lang.langGet("Unused Dashlets"),
                t_layout: Lang.langGet("Schematic Layout of Dashboard"),
                t_dashlet_clients_map: Lang.langGet("Client Map"),
                t_dashlet_clients_list: Lang.langGet("Client Overview"),
                t_dashlet_publish: Lang.langGet("Publish"),
                t_dashlet_mediapool: Lang.langGet("Mediapool"),
                t_dashlet_journal: Lang.langGet("Recent Activities"),
                t_close: Lang.langGet("Close"),
                t_cancel: Lang.langGet("Cancel"),
                t_save: Lang.langGet("Save"),

                strict_mode: false,
                saving: false,
                modalName: 'dashboard-settings',
                elementsPerRowClass: 'two-in-a-row',

                dragulaObject: null,
                loading: false,

                initUnusedDashlets: [],
                initCol1Dashlets: [],
                initCol2Dashlets: [],

                initDashletSettings: [],
                dashletSettings: [],

                frameStyles: {},
            }
        },
        watch: {
            maxBodyHeight: function () {
                this.calcFrameStyles();
            },
        },
        methods: {
            calcFrameStyles: function () {
                let height = this.maxInnerHeight - 22 - 10;
                if(this.$refs.titleRow) {
                    height = height -  $(this.$refs.titleRow).outerHeight(true);
                }
                this.frameStyles = {
                    height: height + 'px'
                }
            },
            setupDragula: function () {
                let containers = [
                    document.querySelector('.dashlets-list'),
                    document.querySelector('.dashboard-canvas'),
                ];

                this.dragulaObject = dragula(containers, {
                    isContainer: function (el) {
                        return el.classList.contains('dashboard-canvas') || el.classList.contains('dashlets-list') ;
                    },
                    moves: function (el, source, handle, sibling) {
                        return el.classList.contains('mini-dashlet');
                    },
                    accepts: function (el, target, source, sibling) {
                        return target.classList.contains('dashboard-canvas') || target.classList.contains('dashlets-list');
                    },
                    revertOnSpill: true,
                    removeOnSpill: false,
                    mirrorContainer: document.getElementById('app'),
                }).on('drop', (el, target, source, sibling) => {
                    let unusedDashlets = [];
                    let col1Dashlets = [];
                    let col2Dashlets = [];
                    for(let dashlet of this.$refs['dashlets-list'].children) {
                        unusedDashlets.push(dashlet.getAttribute('data-name'));
                    }
                    for(let dashlet of this.$refs['dashboard-canvas-1'].children) {
                        col1Dashlets.push(dashlet.getAttribute('data-name'));
                    }
                    for(let dashlet of this.$refs['dashboard-canvas-2'].children) {
                        col2Dashlets.push(dashlet.getAttribute('data-name'));
                    }

                    this.unusedDashlets = unusedDashlets;
                    this.col1Dashlets = col1Dashlets;
                    this.col2Dashlets = col2Dashlets;

                }).on('drag', function (el, source) {
                }).on('cancel', function (el, source) {
                });
            },
            updateDashboardData: function () {
                if((JSON.stringify(this.initCol1Dashlets) !== JSON.stringify(this.col1Dashlets) ||
                    JSON.stringify(this.initCol2Dashlets) !== JSON.stringify(this.col2Dashlets) ||
                    JSON.stringify(this.initDashletSettings) !== JSON.stringify(this.dashletSettings))) {

                    axios.post('/administration/wi-customization/dashboard-data', {
                        layout: JSON.stringify({
                            unused: this.unusedDashlets,
                            col1: this.col1Dashlets,
                            col2: this.col2Dashlets,
                        }),
                        settings: JSON.stringify(this.dashletSettings),
                    }).then((response) => {
                        this.loading = false;
                        EaseEventBus.fire('hideModal', this.modalName);
                        location.reload();
                    }).catch((error) => {
                        console.log(error);
                    });
                } else {
                    EaseEventBus.fire('hideModal', this.modalName);
                }
            },
            loadLayout: function () {
                this.loading = true;
                axios.get('/administration/wi-customization/dashboard-data').then((response) => {
                    this.loading = false;
                    this.initUnusedDashlets = response.data.layout.unused.slice();
                    this.initCol1Dashlets = response.data.layout.col1.slice();
                    this.initCol2Dashlets = response.data.layout.col2.slice();
                    this.initDashletSettings = response.data.settings;

                    this.dashletSettings = JSON.parse(JSON.stringify(this.initDashletSettings));
                    this.unusedDashlets = JSON.parse(JSON.stringify(this.initUnusedDashlets));
                    this.col1Dashlets = JSON.parse(JSON.stringify(this.initCol1Dashlets));
                    this.col2Dashlets = JSON.parse(JSON.stringify(this.initCol2Dashlets));
                }).catch((error) => {

                });
            }
        },
        mounted: function () {
            EaseEventBus.listen('reinitializeDragula', () => {
                if (this.dragulaObject !== null) {
                    this.dragulaObject.destroy();
                }

                this.setupDragula();

                EaseEventBus.fire('doneReinitializeDragula');
            });
            EaseEventBus.listen('showModal', (modalName) => {
                if (this.modalName === modalName) {
                    this.loadLayout();
                }
            });

            this.$nextTick(() => {
                EaseEventBus.fire('reinitializeDragula');
            });
        }
    }
</script>
